import React from 'react';

const LanguageSwitch = ({ language, setLanguage, isDarkMode }) => {
  const toggleLanguage = () => {
    setLanguage(language === 'es' ? 'en' : 'es');
  };
  return (
    <button
      onClick={toggleLanguage}
      className={`px-3 py-1 rounded-lg border transition-all duration-300 hover:scale-105 font-medium text-sm ${
        language === 'es'
          ? isDarkMode
            ? 'bg-red-800 border-red-700 text-white hover:bg-red-700'
            : 'bg-red-800 border-red-700 text-white hover:bg-red-700'
          : isDarkMode
            ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600 hover:text-white'
            : 'bg-gray-200 border-gray-300 text-gray-700 hover:bg-gray-300 hover:text-gray-900'
      }`}
    >
      {language === 'es' ? 'ES' : 'EN'}
    </button>
  );
};

export default LanguageSwitch;
